import { createSlice } from '@reduxjs/toolkit';
import { fmDashboardActions } from './dashboard.action';


interface DashboardState {
  loading: boolean;
  success: any;
  error: any;

  allInvoiceListing: any;
  allInvoiceListingError: any;
  allInvoiceListingPaginations: any;
  allInvoiceListingFiltersData: any;

  cashFlowListing: any;
  cashFlowListingError: any;
  cashFlowListingPaginations: any;
  cashFlowListingFiltersData: any;

  accountPayableListing: any;
  accountPayableListingError: any;
  accountPayableListingPaginations: any;
  accountPayableListingFiltersData: any;
}
const initialState: DashboardState = {
  loading: false,
  success: null,
  error: null,

  allInvoiceListing: [],
  allInvoiceListingError: null,
  allInvoiceListingPaginations: {},
  allInvoiceListingFiltersData: null,

  cashFlowListing: [],
  cashFlowListingError: null,
  cashFlowListingPaginations: {},
  cashFlowListingFiltersData: null,

  accountPayableListing: [],
  accountPayableListingError: null,
  accountPayableListingPaginations: {},
  accountPayableListingFiltersData: null,
};

const fmDashboardSlice = createSlice({
  name: "fmDashboardSlice",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      // -------- cases of project manager assigned projects list api data -------
      .addCase(fmDashboardActions.getAllInvoicesListingAction.pending, (state, action) => {
        state.allInvoiceListingError = "";
        state.allInvoiceListing = [];
        state.allInvoiceListingPaginations = {};
        state.allInvoiceListingFiltersData = action?.meta?.arg;
      })
      .addCase(fmDashboardActions.getAllInvoicesListingAction.fulfilled, (state, action) => {
            if (action.payload.data.data) {
              state.allInvoiceListing= action.payload.data.data;
              state.allInvoiceListingError = "";
              state.allInvoiceListingPaginations = action.payload.data.pagination;
            } else {
              state.error = "Unable to fetch projects list";
              state.allInvoiceListingPaginations = {}
            }
      })
      .addCase(fmDashboardActions.getAllInvoicesListingAction.rejected, (state, action:any) => {
            state.allInvoiceListing = [];
            state.allInvoiceListingError = action?.error?.message || "Unable to fetch projects list";
            state.allInvoiceListingPaginations = {}
      })

      // -------- cases of cash flow listing api data -------
      .addCase(fmDashboardActions.getCashFlowListingAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;

        state.cashFlowListing = [];
        state.cashFlowListingError = null;
      })
      .addCase(fmDashboardActions.getCashFlowListingAction.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.data?.status === 200) {
          
          state.cashFlowListing= action.payload.data.data;
          state.cashFlowListingFiltersData = action?.meta?.arg?.filters;
          state.cashFlowListingPaginations = action.payload.data.pagination;
          state.cashFlowListingError = null;

          state.success = action?.payload?.data?.message;
          state.error = null;
        } else {
          state.cashFlowListing = [];
          state.success = null;
          state.error = action?.payload?.data?.message ?? "Unable to fetch cash flow list";
        }
      })
      .addCase(fmDashboardActions.getCashFlowListingAction.rejected, (state, action:any) => {
        state.cashFlowListing = [];
        state.success = null;
        state.cashFlowListingError = action?.error?.message || "Unable to fetch cash flow list";
      })

      // -------- cases of account payable listing api data -------
      .addCase(fmDashboardActions.getAccountPayableListingAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.accountPayableListing = [];
        state.accountPayableListingError = null;
      })
      .addCase(fmDashboardActions.getAccountPayableListingAction.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.data?.status === 200) {
          state.accountPayableListing = action.payload.data.data;
          state.accountPayableListingFiltersData = action?.meta?.arg?.filters;
          state.accountPayableListingPaginations = action.payload.data.pagination;
          state.accountPayableListingError = null;
          state.success = action?.payload?.data?.message;
          state.error = null;
        } else {
          state.accountPayableListing = [];
          state.success = null;
          state.error = action?.payload?.data?.message ?? "Unable to fetch account payable list";
        }
      })
      .addCase(fmDashboardActions.getAccountPayableListingAction.rejected, (state, action: any) => {
        state.accountPayableListing = [];
        state.success = null;
        state.accountPayableListingError = action?.error?.message || "Unable to fetch account payable list";
      })
  },
});

export const { } = fmDashboardSlice.actions;
export default fmDashboardSlice.reducer;